var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showFoldersInSearch && _vm.scope.row.path)?_c('span',[_vm._v(_vm._s(_vm.scope.row.path + ' / '))]):_vm._e(),_vm._v(" "+_vm._s(_vm.scope.row.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }